import PropTypes from "prop-types";
import {useEffect} from "react";
import {Outlet} from "react-router-dom";
import ErrorBoundary from "common/components/layout/error-boundary";
import Notifications from "common/components/layout/notifications";
import useAppContext from "common/hooks/use-app-context";
import traitify from "common/lib/traitify";
import Footer from "./footer";
import Navbar from "./navbar";

function Container({footer = true, navbar = true}) {
  const {app: {api_key: apiKey, iframe}} = useAppContext();

  useEffect(() => { traitify.http.authKey = apiKey; }, [apiKey]);

  return (
    <div className="flex flex-col h-screen">
      {navbar && !iframe && <Navbar />}
      <Notifications />
      <main className="flex-auto" id="main" role="main" tabIndex="-1">
        <ErrorBoundary><Outlet /></ErrorBoundary>
      </main>
      {footer && !iframe && <Footer />}
    </div>
  );
}

Container.propTypes = {footer: PropTypes.bool, navbar: PropTypes.bool};

export default Container;
